import { ColumnPattern } from '@/common/components/Table'

export const establishmentPointsColumns: ColumnPattern[] = [
  { label: 'Estabelecimento', value: 'establishment' },
  { label: 'Total gasto em R$', value: 'total_amount_consumed' },
  { label: 'Pontos atuais', value: 'available_points_total' },
  { label: 'Pontos acumulados', value: 'earned_points_total' },
  { label: 'Ult. Atualização', value: 'most_recent_reward_ledger_created_at' },
]
